module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('svg', {
    attrs: {
      "width": "41",
      "height": "41",
      "viewBox": "0 0 41 41",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('circle', {
    attrs: {
      "cx": "20.5",
      "cy": "20.5",
      "r": "20.5",
      "fill": "#E8E7E5"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M29.5484 28.9717H11.1533H9.57654L8.52539 27.9205V16.3579L9.05097 14.2556L10.6277 13.73H17.9857L17.4602 9.52539H22.7159L22.1904 13.73H30.074L31.1251 14.2556L31.6507 15.8323V26.8694L31.1251 28.4461L29.5484 28.9717Z",
      "fill": "white"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M10.7702 29.55H29.4062C30.9173 29.55 32.1765 28.2908 32.1765 26.7798V15.7996C32.1765 14.2886 30.9173 13.0294 29.4062 13.0294H22.8585L23.211 10.2088C23.2614 9.90662 23.1607 9.60441 22.9592 9.35257C22.7577 9.10074 22.4555 9 22.1533 9H18.0232C17.721 9 17.4187 9.1511 17.2173 9.35257C17.0158 9.60441 16.9151 9.90662 16.9654 10.2088L17.318 13.0294H10.7702C9.25919 13.0294 8 14.2886 8 15.7996V26.7798C8 28.2908 9.25919 29.55 10.7702 29.55ZM17.9728 10.0577H18.0232H22.1533C22.2037 10.0577 22.2037 10.0577 22.2037 10.0577V10.1081L21.7 14.1375H21.6496H18.5268H18.4765L17.9728 10.1081C17.9728 10.0577 17.9728 10.0577 17.9728 10.0577ZM9.00735 15.7996C9.00735 14.8426 9.81324 14.0368 10.7702 14.0368H17.4188L17.4691 14.2886C17.5195 14.7419 17.9728 15.1449 18.5268 15.1449H21.6496C22.2037 15.1449 22.657 14.7923 22.7074 14.2886L22.7577 14.0368H29.4062C30.3632 14.0368 31.1691 14.8426 31.1691 15.7996V26.7798C31.1691 27.7368 30.3632 28.5426 29.4062 28.5426H10.7702C9.81324 28.5426 9.00735 27.7368 9.00735 26.7798V15.7996Z",
      "fill": "black"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M14.2956 20.988C15.6555 20.988 16.7132 19.3762 16.7132 18.0163C16.7132 16.7067 15.6051 15.5986 14.2956 15.5986C12.986 15.5986 11.8779 16.6564 11.8779 18.0163C11.8779 19.3762 12.9357 20.988 14.2956 20.988ZM14.2956 16.606C15.0511 16.606 15.7059 17.2608 15.7059 18.0163C15.7059 18.8725 15.0007 19.9806 14.2956 19.9806C13.5904 19.9806 12.8853 18.8725 12.8853 18.0163C12.8853 17.2104 13.4897 16.606 14.2956 16.606Z",
      "fill": "black"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M10.8201 26.9808H17.6197C17.9219 26.9808 18.1234 26.7794 18.1234 26.4772V25.0669C18.073 23.2536 16.6124 21.793 14.7991 21.793H13.6407C11.8274 21.793 10.3668 23.2033 10.3164 25.0165V26.4772C10.3164 26.729 10.5682 26.9808 10.8201 26.9808ZM13.6407 22.8003H14.7991C16.0583 22.8003 17.116 23.8077 17.116 25.0669V25.9735H11.3238V25.0669C11.3741 23.8077 12.3815 22.8003 13.6407 22.8003Z",
      "fill": "black"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M19.635 17.9654H24.5711C24.8733 17.9654 25.0747 17.7639 25.0747 17.4617C25.0747 17.1595 24.8733 16.958 24.5711 16.958H19.635C19.3328 16.958 19.1313 17.1595 19.1313 17.4617C19.1313 17.7639 19.3328 17.9654 19.635 17.9654Z",
      "fill": "black"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M19.635 20.6851H24.5711C24.8733 20.6851 25.0747 20.4836 25.0747 20.1814C25.0747 19.8792 24.8733 19.6777 24.5711 19.6777H19.635C19.3328 19.6777 19.1313 19.8792 19.1313 20.1814C19.1313 20.4836 19.3328 20.6851 19.635 20.6851Z",
      "fill": "black"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M19.2822 22.9021C19.2822 23.2043 19.4837 23.4058 19.7859 23.4058H29.3558C29.658 23.4058 29.8594 23.2043 29.8594 22.9021C29.8594 22.5999 29.658 22.3984 29.3558 22.3984H19.7859C19.5341 22.3984 19.2822 22.6503 19.2822 22.9021Z",
      "fill": "black"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M29.3558 25.1172H19.7859C19.4837 25.1172 19.2822 25.3187 19.2822 25.6209C19.2822 25.9231 19.4837 26.1245 19.7859 26.1245H29.3558C29.658 26.1245 29.8594 25.9231 29.8594 25.6209C29.8594 25.3187 29.658 25.1172 29.3558 25.1172Z",
      "fill": "black"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M20.0881 12.9287C20.3904 12.9287 20.5918 12.7273 20.5918 12.4251V11.7703C20.5918 11.4681 20.3904 11.2666 20.0881 11.2666C19.7859 11.2666 19.5845 11.4681 19.5845 11.7703V12.4251C19.5845 12.6769 19.8363 12.9287 20.0881 12.9287Z",
      "fill": "black"
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-55535156","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/registration/progressSideBar/icons/PersonalIcon.vue
// module id = 641
// module chunks = 0